export default "__VITE_ASSET__DtE3iblU__"